import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import "../../../css/thumbnails/thumbnails.scss";

//import main module definition.
import thumbnailsModule from './thumbnailsModule';

importFilesUnderPath(require.context("./components/", true, /\.js$/));
importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));

let templateContext = require.context("./", true, /\.html$/);

templateCacheGenerator(angular, 'thumbnailsTemplates', templateContext, null);

export default thumbnailsModule;